// eslint-disable-next-line @typescript-eslint/triple-slash-reference, spaced-comment
/// <reference types="@ps/web-spade-sdk/types" />
import { getWindow } from '@ps/web-core-utils';
import type { InitSchema } from '@ps/web-spade-sdk/types';
import { useRef } from 'react';
import { useSelector } from 'react-redux';

import { select } from '../../';

export const useSpadeSdk = () => {
  const locale = useSelector(select.locale.get) as InitSchema['locale'];

  const spadeSdk = useRef(getWindow()?.Spade?.init({ locale }));

  return spadeSdk.current;
};
